import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { CarouselButton } from '../CarouselButton/CarouselButton.esm.js';
import { carouselNavigationStyles } from './ CarouselNavigation.styles.esm.js';

function CarouselNavigation({ deviceType, itemsInView, canScrollPrev, canScrollNext, loop, scrollPrev, scrollNext, inverse, remainingSlidesNext, remainingSlidesPrev, hideCarouselButtonOnDisable, carouselButtonVariant = "in-page", }) {
    const leftButtonRef = useRef(null);
    const rightButtonRef = useRef(null);
    // Only show navigation on desktop
    if (deviceType !== "desktop")
        return null;
    const styles = carouselNavigationStyles();
    // Map carouselButtonVariant to position variant
    // "floating" and "floating-over-image" should position buttons over the carousel
    // "in-page" should position buttons under the carousel
    const positionVariant = carouselButtonVariant === "floating" || carouselButtonVariant === "floating-over-image"
        ? "over"
        : "under";
    const prevLabel = remainingSlidesPrev === 1 || itemsInView === 1
        ? "Show previous item"
        : "Show previous items";
    const nextLabel = remainingSlidesNext === 1 || itemsInView === 1
        ? "Show next item"
        : "Show next items";
    const handlePrevClick = (e) => {
        var _a;
        e.stopPropagation();
        scrollPrev();
        if (remainingSlidesPrev - itemsInView <= 0 && !loop) {
            (_a = rightButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    const handleNextClick = (e) => {
        var _a;
        e.stopPropagation();
        scrollNext();
        if (remainingSlidesNext - itemsInView <= 0 && !loop) {
            (_a = leftButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    const handleKeyDownPrev = (e) => {
        var _a;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            scrollPrev();
            if (remainingSlidesPrev - itemsInView <= 0 && !loop) {
                (_a = rightButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
    };
    const handleKeyDownNext = (e) => {
        var _a;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            scrollNext();
            if (remainingSlidesNext - itemsInView <= 0 && !loop) {
                (_a = leftButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
    };
    const renderButton = (direction, onClick, onKeyDown, label, ref, isDisabled) => {
        if (hideCarouselButtonOnDisable && isDisabled) {
            return null;
        }
        return (jsx(CarouselButton, { variant: carouselButtonVariant, inverse: inverse, direction: direction, onClick: onClick, onKeyDown: onKeyDown, "aria-label": label, ref: ref, disabled: isDisabled, className: styles.base({
                disabled: isDisabled,
                position: positionVariant,
                direction,
            }) }));
    };
    const renderNavigation = () => (jsxs(Fragment, { children: [renderButton("left", handlePrevClick, handleKeyDownPrev, prevLabel, leftButtonRef, !canScrollPrev && !loop), renderButton("right", handleNextClick, handleKeyDownNext, nextLabel, rightButtonRef, !canScrollNext && !loop)] }));
    return renderNavigation();
}

export { CarouselNavigation };
